import { categories } from '@/mocks/categories';
import { allComics } from '@/mocks/comics';
import { faqs } from '@/mocks/faq';

export function getHomepageSchema() {
  const baseUrl = 'https://hanman.com';
  return {
    organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '韩漫网',
      url: baseUrl,
      description: '免费韩漫大全，好看的韩国漫画在线观看平台。提供最新最全的韩漫资源，漫画韩漫网址首选。',
      logo: `${baseUrl}/logo.png`,
      sameAs: [],
    },
    website: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '韩漫网',
      url: baseUrl,
      description: '韩漫网 - 免费韩漫大全 | 好看的韩国漫画 | 漫画韩漫网址 | 韩漫在线观看',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${baseUrl}/search?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    webpage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '韩漫网 - 免费韩漫大全',
      description: '韩漫网利用漫画网址实现免费韩漫大全与好看韩国漫画的韩漫在线观看，功能全面满足您的需求。',
      url: baseUrl,
      isPartOf: {
        '@type': 'WebSite',
        name: '韩漫网',
        url: baseUrl,
      },
      about: {
        '@type': 'Thing',
        name: '韩国漫画',
        description: '免费韩漫在线阅读平台，涵盖恋爱、奇幻、动作、搞笑、悬疑、BL、GL等多种分类。',
      },
    },
    breadcrumb: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: baseUrl,
        },
      ],
    },
    itemList: {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: allComics.slice(0, 10).map((comic, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'ComicStory',
          name: comic.title,
          url: `${baseUrl}/article/${comic.id}`,
          author: {
            '@type': 'Person',
            name: comic.author,
          },
          datePublished: comic.chapters[0]?.date,
          description: comic.description,
        },
      })),
    },
    faq: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
    categoryList: {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: '韩漫分类',
      itemListElement: categories.map((cat, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Thing',
          name: cat.name,
          description: cat.description,
          url: `${baseUrl}/category/${cat.id}`,
        },
      })),
    },
  };
}